const d = "Wird geladen …", a = {
  loading: d
};
export {
  a as default,
  d as loading
};
